import { useState } from 'react';

import { ViewProps } from './draw.constants';
import SubActivityPrint from '../sub-activity/sub-activity-print';
import DrawCanvasPreview from './draw-canvas-preview';
import * as Styled from './draw-print.style';
import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';

const DrawStaticPreview = ({
  id,
  properties,
  subActivityProperties,
}: ViewProps) => {
  const { lang } = useActivityBuilderPresentContext();

  const imageUrl = properties.image?.responsive?.[0].urls?.[0]?.url || '';
  const [previewRef, setPreviewRef] = useState<HTMLDivElement | null>(null);

  const paddingTop =
    (properties.dimensionData.height / properties.dimensionData.width) * 100;

  return (
    <SubActivityPrint subActivityDetails={subActivityProperties}>
      <div ref={setPreviewRef}>
        <Styled.DrawPrint
          style={{
            paddingTop: `${paddingTop}%`,
          }}
        >
          {previewRef && (
            <DrawCanvasPreview
              key={`${id}-${properties.draw?.updatedAt}-${properties.image?.original}`}
              id={`print-${id}`}
              imageUrl={imageUrl}
              dimensionsData={properties.dimensionData}
              questionData={properties.draw || undefined}
              containerEl={previewRef}
              language={lang}
            />
          )}
        </Styled.DrawPrint>
      </div>
    </SubActivityPrint>
  );
};

export default DrawStaticPreview;
